<template>
  <div class="d-flex in-component">
    <div
      class="d-flex in-component">
      <v-col
        class="pt-3"
        cols="3">
        <ValidationProvider
          v-slot="{ errors }"
          :name="label"
          :rules="disableGroup ? rules : null">
          <v-text-field
            v-model="value.min"
            :type="type"
            solo
            dense
            :disabled="!disableGroup"
            class="range-text-field"
            :max="type === 'datetime-local' ? value.max : null"
            :error-messages="errors[0]"
            @input="watching('min', $event)" />
        </ValidationProvider>
      </v-col>
      <v-col class="d-flex justify-end pt-3">
        ถึง
      </v-col>
      <v-col
        cols="3"
        class="pt-3">
        <ValidationProvider
          v-slot="{ errors }"
          :name="label"
          :rules="disableGroup ? rules : null">
          <v-text-field
            v-model="value.max"
            :type="type"
            solo
            dense
            :disabled="!disableGroup"
            class="range-text-field"
            :min="type === 'datetime-local' ? value.min : null"
            :error-messages="errors[0]"
            @input="watching('max', $event)" />
        </ValidationProvider>
      </v-col>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'number'
    },
    value: {
      type: Object,
      default () {
        return {
          min: this.type === 'datetime-local' ? this.$dayjs().format('YYYY-MM-DD HH:mm') : 0,
          max: this.type === 'datetime-local' ? this.$dayjs().format('YYYY-MM-DD HH:mm') : 0
        }
      }
    },
    rules: {
      type: String,
      default: ''
    },
    disableGroup: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    watching (field, val) {
      clearTimeout(this.searching)
      this.searching = setTimeout(() => {
        this.actionHandle(field, val)
      }, 1000)
    },
    actionHandle (field, val) {
      if (this.type === 'datetime-local') {
        this.value[field] = this.$dayjs(this.value[field]).utc().format('YYYY-MM-DDTHH:mm')
      } else if (field === 'min' && +val > +this.value.max) {
        this.value.max = this.value.min
      } else if (field === 'max' && +this.value.min > +val) {
        this.value.min = this.value.max
      }

      this.$emit('input', this.value)
    }
  }
}
</script>

<style>
.range-text-field {
  width: 120px;
  margin-top: -10px !important;
}

.range-text-field.v-text-field .v-input__slot {
  width: 170px;
}
.range-text-field.v-text-field.v-text-field--solo .v-input__control input {
  width: 110px;
}
</style>
